/** AI API client for brainstorming, credits, and BYOK key management. */

import { apiGet, apiPost } from '@/api/client';

export interface BrainstormResult {
  result: string | string[];
  creditsUsed: number;
  creditsRemaining: number;
}

export interface AiCredits {
  used: number;
  limit: number;
  month: string;
  hasByokKey: boolean;
}

export async function brainstorm(
  nodeText: string,
  context: string,
  mode: 'expand' | 'summarize' | 'question',
  question?: string,
): Promise<BrainstormResult> {
  return apiPost<BrainstormResult>('/ai/brainstorm', {
    nodeText,
    context,
    mode,
    question,
  });
}

export async function getAiCredits(): Promise<AiCredits> {
  return apiGet<AiCredits>('/ai/credits');
}

export async function saveByokKey(apiKey: string): Promise<void> {
  await apiPost('/ai/byok', { apiKey });
}
